import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.ol`
  display: flex;
  height: 80px;
  width: 100%;
  padding: 0 16px;
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray};
`;

export const Day = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.OuterSpace};
`;
